module.exports = __webpack_public_path__ + "static/img/realTimeSelection.97cc589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkBg/realTimeSelection.jpg
// module id = 3v+q
// module chunks = 1